import React from 'react';
import { Typography } from 'antd';
import { CandidateResumeAiAssessment } from '../models/candidate-summary.model';

const labels = {
  AI_ASSISTANCE_DISCLOSURE: 'AI assistance disclosed',
  GENERATION_ARTIFACT: 'Generation artifact',
  JD_MIRRORING: 'Job description wording overlap',
};

export function CandidateResumeAiReview({
  review,
}: {
  review?: CandidateResumeAiAssessment;
}) {
  return (
    <section
      className="ai-brief-writing-review"
      aria-label="Resume writing signals"
    >
      <Typography.Title level={4}>Resume writing signals</Typography.Title>
      {!review ? (
        <p>
          This assessment predates the writing review. Regenerate the assessment
          to evaluate the resume against this job description.
        </p>
      ) : (
        <>
          {review.status === 'COMPLETED' &&
          review.flaggedTextPercentage != null ? (
            <>
              <p>
                <strong>
                  {review.flaggedTextPercentage}% of resume text flagged for
                  review
                </strong>{' '}
                ({review.flaggedWordCount} of {review.reviewedWordCount} words).
              </p>
              {review.signals.length === 0 && (
                <p>
                  No supported writing signals were found. This does not
                  establish human authorship.
                </p>
              )}
            </>
          ) : (
            <p>
              {review.status === 'INSUFFICIENT_TEXT'
                ? 'There is not enough resume text or job description to calculate a meaningful percentage.'
                : 'The writing review is unavailable. Regenerate the assessment to try again.'}
            </p>
          )}
          {review.resumeFilename && (
            <p>
              Reviewed resume: <strong>{review.resumeFilename}</strong>
              {review.evaluatedAt && (
                <> · {new Date(review.evaluatedAt).toLocaleString()}</>
              )}
            </p>
          )}
          {review.signals.length > 0 && (
            <ol>
              {review.signals.map((signal, index) => (
                <li key={index}>
                  <strong>{labels[signal.type]}</strong>
                  <blockquote>{signal.resumeExcerpt}</blockquote>
                  {signal.jobDescriptionExcerpt && (
                    <p>Job description: “{signal.jobDescriptionExcerpt}”</p>
                  )}
                  <p>{signal.reason}</p>
                </li>
              ))}
            </ol>
          )}
          <p className="ai-brief-writing-review__note">{review.disclaimer}</p>
        </>
      )}
      <p className="ai-brief-writing-review__note">
        Internal recruiter review. Excluded from the client PDF and clipboard
        brief.
      </p>
    </section>
  );
}
